import { useCallback, useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { adminApi } from "../../lib/api";

export const OwnerAlerts = ({ onOpenActivity }) => {
  const [items, setItems] = useState([]);
  const load = useCallback(() => {
    adminApi.get("/admin/alerts").then((r) => setItems(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => { clearInterval(t); };
  }, [load]);
  const ack = (id) => adminApi.post(`/admin/alerts/${id}/ack`).then(load);
  return items.map((a) => (
    <div key={a.id} data-testid={`owner-alert-${a.id}`} className="flex flex-wrap items-center justify-between gap-3 border border-red-500/60 bg-red-500/15 px-5 py-3 text-sm text-red-100">
      <span className="flex items-center gap-2"><AlertTriangle className="h-5 w-5 shrink-0 text-red-400" />
        <span><b>Security alert:</b> {a.message} <span className="text-red-300/80">({new Date(a.created_at).toLocaleString("en-IN")})</span></span></span>
      <span className="flex gap-2">
        <button onClick={onOpenActivity} data-testid={`owner-alert-activity-${a.id}`} className="border border-red-400/60 px-3 py-1 text-xs hover:bg-red-500/20">View activity</button>
        <button onClick={() => ack(a.id)} data-testid={`owner-alert-dismiss-${a.id}`} className="bg-red-600 px-3 py-1 text-xs font-semibold text-white hover:bg-red-500">Dismiss</button>
      </span>
    </div>
  ));
};
